module.exports = __webpack_public_path__ + "static/media/catapult-logo-bw.608eb06a.png";